import { forwardRef, type PropsWithChildren } from 'react';
import { Button, VStack } from '@direct-frontend/components';

interface CourierSubmitButtonProps extends PropsWithChildren {
    isSubmitting: boolean;
    onSubmit: VoidFunction;
}

export const CourierSubmitButton = forwardRef<HTMLElement, CourierSubmitButtonProps>(
    function CourierSubmitButton(props, forwardedRef) {
        const { children, isSubmitting, onSubmit } = props;

        return (
            <VStack ref={forwardedRef} gap="16">
                <Button size="m" color="accent" isDisabled={isSubmitting} onClick={onSubmit}>
                    {children}
                </Button>
            </VStack>
        );
    }
);
